module.exports = __webpack_public_path__ + "static/media/functionalClothing-small.20e5ef1f.jpg";